import { animation } from './modules/message/animation';
animation();


const isMobile = window.matchMedia("(max-width: 768px)").matches;

if(!isMobile) {
  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      location.reload();
    }, 500); // ← 0.5秒後にリロード
  });
}


